import moment from "moment";

const formatDateWithDay = (date: any) => {
  return moment(date).format("dddd, DD MMMM YYYY");
};
export default formatDateWithDay;
